import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Responses',
    isLink: true,
  },
];

const Title: PageTitle = {
  title: 'Responses',
};

export { Breadcrumbs, Title };
